import { asyncScope } from "./utils";
import type { NavigationRaw } from "..";
import type { NexusHandler } from "../../nexus/function/function.types";
import { defineContext, historyPatched } from "./history";
import { navigateCrossDocument } from "./navigation";

const log = asyncScope.scope("navigate");

/**
 *
 */
export const navigate: NexusHandler<NavigationRaw["navigate"]> = async (
  urlOrString = "",
  o = {},
) => {
  const { history: navigationType = "push", state, info } = o;
  log.debug("Navigation request:", navigationType, "for:", urlOrString, "with options", o);

  if (navigationType === "document") return navigateCrossDocument(urlOrString, info);

  /*                                                                */
  const method = historyPatched[`${navigationType}State`];
  if (!method) return false;

  /*                                                       */
  const nextUrl = new URL(urlOrString, location.href);

  /*                                                           */
  log.info("Navigate to", nextUrl.href, "as", navigationType, "with state", state);
  method.call(defineContext({ ...o }), state, "", nextUrl);
  return true;
};
